export default __webpack_public_path__ + "static/media/powder.1b1be4f5.jpg";